import Api from "../utils/api-interceptor";

export const GetRecommendedExercises = async (obj: any) => {
  return Api.post("Exercises/GetVSTRecommendedExercises", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const GetRecentExerciseSearches = async (obj: any) => {
  return Api.post("Exercises/GetRecentSearches", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const SaveRecommendedExercises = async (obj: any) => {
  return Api.post("Exercises/SaveRecommendedExercises", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const SaveRecentExerciseSearch = async (obj: any) => {
  return Api.post("Exercises/SaveRecentSearches", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const SavePatientEmail = async (obj: any) => {
  return Api.post("Exercises/SavePatientEmail", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const GetExercisesLookupDetails = async (obj: any) => {
  return Api.post("Exercises/GetExercisesLookupDetail", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const GetFilteredExercises = async (obj: any) => {
  return Api.post("Exercises/GetFilteredVSTRecommendedExercises", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const GetAssignedExercisesData = async (obj: any) => {
  return Api.post("Exercises/GetAssignedExercisesReportData", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const SaveEmailStatusAndReportUrl = async (obj: any) => {
  return Api.post("Exercises/SaveEmailStatusAndReportUrl", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const SendExceptionEmail = async (obj: any) => {
  return Api.post("EmailException/SendExceptionEmail", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const GenerateExercisePlanPdf = async (obj: any) => {
  return Api.post("Exercises/GenerateExercisePlanPdf", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};

export const SavePdfUrlAgainstPatient = async (obj: any) => {
  return Api.post("Exercises/SavePdfUrlAgainstPatient", obj).then(
    (response) => {
      return response;
    },
    (error) => {}
  );
};
